import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DefaultOption from 'react-select/lib/Option';
import _ from 'lodash';
import api from 'utils/api';
import ReactSelect from 'react-select';

const fetchOptions = _.debounce((input, setOptions) => {
  api
    .get('/guest_portal/api/organizations', { params: { search_term: input } })
    .then(response => setOptions(null, { options: response.data.organizations }));
  return null;
}, 150);

const cityStateRenderer = cityStates => {
  if (cityStates.length >= 4) {
    return (
      <div>{`    - located in ${cityStates.length} cities including ${cityStates
        .slice(0, 3)
        .join('; ')}`}</div>
    );
  } else if (cityStates.length >= 1) {
    return <div>{`    - located in ${cityStates.slice(0, 3).join('; ')}`}</div>;
  }
  return null;
};

// NB: This can't be a stateless functional component, because it's given a ref
class OrgOption extends Component {
  // eslint-disable-line
  render() {
    return (
      <DefaultOption {...this.props}>
        <div>{this.props.option.name}</div>
        <i style={{ fontSize: 10 }}>{cityStateRenderer(this.props.option.cityStates)}</i>
      </DefaultOption>
    );
  }
}

const trueFunc = () => true;

const OrganizationSelection = ({ value, onChange }) => (
  <ReactSelect.Async
    loadOptions={fetchOptions}
    valueKey="id"
    labelKey="name"
    value={value}
    onChange={onChange}
    optionComponent={OrgOption}
    filterOption={trueFunc}
  />
);

OrganizationSelection.displayName = 'OrganizationSelection';

OrganizationSelection.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    score: PropTypes.number,
    cityStates: PropTypes.array.isRequired,
  }),
  onChange: PropTypes.func,
};

export default OrganizationSelection;
